import { type MsalConfig } from '@efdigital/ll-addon-auth/authenticators/msal/msal-config';
import { type Apis } from '@efdigital/ll-addon-auth/types/apis';
import { assert } from '@ember/debug';
import loadConfigFromMeta from '@embroider/config-meta-loader';
import type { AppsConfig } from 'config/ll-apps';
import type { MediaConfig } from 'config/ll-cdk-media';

const config = loadConfigFromMeta('@efdigital/ll-admin-v2') as unknown;

assert(
  'config is not an object',
  typeof config === 'object' && config !== null
);
assert(
  'modulePrefix was not detected on your config',
  'modulePrefix' in config && typeof config.modulePrefix === 'string'
);
assert(
  'locationType was not detected on your config',
  'locationType' in config && typeof config.locationType === 'string'
);
assert(
  'rootURL was not detected on your config',
  'rootURL' in config && typeof config.rootURL === 'string'
);
assert(
  'APP was not detected on your config',
  'APP' in config && typeof config.APP === 'object'
);

export default config as {
  modulePrefix: string;
  podModulePrefix?: string;
  locationType: string;
  rootURL: string;
  APP: Record<string, unknown>;
  'll-apps': AppsConfig;
  'll-media': MediaConfig;
  'll-addon-auth-msal': MsalConfig;
  'll-addon-auth-apis': Apis;
} & Record<string, unknown>;
